
import { defineComponent } from 'vue';

const App = defineComponent({
  // setup() {},
});

export default App;
